<template>
  <div class="ban-container">
    <div class="ban-head d-flex justify-between">
      <!-- 左侧Logo -->
      <KuLogo v-if="showLogo && isLogined" style="width:180px;" :collapse="false" />
      <img v-else :src="require('@/assets/logo-platform-defaut.png')" style="width:132px;height:40px;margin-top:8px;margin-left:24px;" alt="" />
      <!-- 切换租户登录 -->
      <div v-if="isLogined" class="box-center" style="height:56px;">
        <el-dropdown placement="left-start" style="color:white;margin-right:30px;" trigger="click">
          <span class="el-dropdown-link">
            <i class="el-icon-arrow-left"></i>
            {{ $t('企业切换') }}
          </span>
          <el-dropdown-menu slot="dropdown">
            <template v-for="item in tenantsList">
              <el-dropdown-item
                v-if="item.status && item.status.code === 'NORMAL'"
                :key="item.name"
                :class="activeTenant === item.code ? 'tenant-active' : ''"
              >
                <div @click="changeTenant(item)">
                  <i class="mr-1" :class="activeTenant === item.code ? 'fa fa-dot-circle-o' : 'fa fa-circle-o'"></i>
                  {{ item.name }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item
                v-else
                :key="item.name"
                :class="activeTenant === item.code ? 'tenant-active' : 'tenant-disabled'"
              >
                <div @click="changeTenant(item)">
                  <i class="mr-1 fa fa-close"></i>
                  {{ item.name }}
                </div>
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="ban-info box-center">
      <div style="background-color:#e9eaea;padding:36px;width:580px;">
        <div class="d-flex flex-column align-center" style="padding:36px 70px;background-color:white;">
          <div style="font-size:36px;font-weight:600;">{{ $t('无法进入该企业') }}</div>
          <div style="font-size:20px;color:#4E5969;margin-top:24px">{{ $t('该企业订阅日期已过期被停止使用，') }}</div>
          <div style="font-size:20px;color:#4E5969;">{{ $t('如需继续使用，请联系商务团队') }}</div>
          <el-button v-if="!isLogined" class="go-back" @click="goBack">{{ $t('返回') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from '@klinx/utils/localstorage';
import { baseAuthorityApi } from '@klinx/base/src/api/index.js';
export default {
  components: {
    KuLogo: () => import('@klinx/components')
  },
  data() {
    return {
      activeTenant: null,
      activeIndex: '0',
      // 是否已登录，已登录才能调用getListTenantsAll等接口
      isLogined: false
    };
  },
  computed: {
    tenantsList() {
      return this.$store.state.account.tenantsList;
    },
    showLogo() {
      return this.$store.state.setting.sidebarLogo;
    },
    menuRoutes() {
      return this.$store.state.account.routes;
    }
  },
  mounted() {
    // 登陆后会多出下面两个属性
    if (this.$route.query.isLogined) {
      this.isLogined = !!this.$route.query.isLogined;
      this.activeTenant = this.$route.query.cliTenant;
    }
  },
  methods: {
    // 返回
    goBack() {
      this.$router.push('/login');
    },
    logout() {
      const param = {
        token: db.get('TOKEN', ''),
        userId: db.get('USER', {
          id: null
        }).id,
        clientId: process.env.VUE_APP_CLIENT_ID,
        tenant: db.get('TENANT')
      };
      baseAuthorityApi.logout(param).finally(() => this.clean());
    },
    clean() {
      db.clear();
      location.reload();
    },
    loadPermissions(userId) {
      baseAuthorityApi
        .getResource({
          userId
        })
        .then(response => {
          const res = response.data;
          console.log(this.$t('用户权限'), res);
          if (res.isSuccess) {
            const authorityResource = res.data;
            const permissionsList = authorityResource.resourceList || [];
            this.$store.commit('account/setPermissions', permissionsList);
            this.$store.commit('account/setAuthorityResource', authorityResource);

            setTimeout(() => {
              location.reload();
            }, 500);
          } else {
            this.logout();
          }
        })
        .catch(() => {
          this.logout();
        });
    },
    // 切换租户登录
    changeTenant(e) {
      localStorage.removeItem('klinx-web-cloud_NOTIFY');
      const param = {
        grantType: 'switch_tenant',
        refreshToken: db.get('REFRESH_TOKEN'),
        tenant: e.code
      };
      baseAuthorityApi
        .login(param)
        .then(response => {
          const res = response.data;
          if (res.isSuccess) {
            this.$message.success(this.$t('正在切换，请稍后'));
            this.$store.commit('account/setToken', res.data[this.$t('token')]);
            this.$store.commit('account/setRefreshToken', res.data['refreshToken']);
            this.$store.commit('account/setExpireTime', res.data['expiration']);
            this.$store.commit('account/setTenant', res.data['tenant']);
            this.$store.commit('account/setUser', {
              id: res.data.userId,
              account: res.data.account,
              name: res.data.name,
              avatar: res.data.avatar,
              workDescribe: res.data.workDescribe
            });
            this.$store.commit('account/setActiveIndex', 0);
            const route = this.menuRoutes[this.activeIndex].children;
            this.$store.commit('account/setCurrentRoutes', route);
            this.$router.replace({
              name: 'Dashboard'
            });
            this.loadPermissions(res.data.userId);
            baseAuthorityApi.getRouter({}).then(response => {
              db.remove('CURRENT_ROUTER');
              const res = response.data;
              let asyncRouter = res.data;
              console.log(this.$t('查询用户可用的所有菜单路由树'), asyncRouter);
              if (!(asyncRouter && asyncRouter.length > 0)) {
                asyncRouter = [];
                this.$message.error(this.$t('当前租户暂未配置菜单权限，请联系管理员'));
              }
              asyncRouter.push({
                alwaysShow: false,
                component: 'error-page/404',
                hidden: false,
                name: '404',
                path: '*'
              });
              // 缓存顶部导航
              db.save('USER_ROUTER', asyncRouter);
              // 缓存侧边导航
              db.save('CURRENT_ROUTER', asyncRouter[0].children);
            });
          } else {
            // 后端返回的过期/禁用提示
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          db.remove('EXPIRE_TIME');
          db.remove('TOKEN');
          db.remove('USER_ROUTER');
          db.remove('PERMISSIONS');
        });
    }
  }
};
</script>

<style lang="less" scoped>

.ban-container {
  width: 100%;
  height:100%;
  background: url('../../assets/login-bg.jpg') no-repeat;
  background-size: cover;
  background-position: center 56px;
  position: relative;
  background-color: #707374;
  .ban-head {
    height: 56px;
    width: 100%;
    background-color: #0f1f2e;
  }
  .ban-info {
    height:calc(100% - 56px);
  }
}

.tenant-active {
  background-color: #fff0e6;
  color: #ff7818;
}

.tenant-disabled {
  background-color: #f4f4f5;
  color: #d1d1d1;
}

.go-back {
  background:#3a71ff;
  color:white;
  width:80%;
  margin-top:24px;
  font-size:20px;
  height:56px;
  &:hover {
    opacity: 0.7;
  }
}
</style>
